import { DirectionalCostTypeBase } from './base/directional-cost-type-base';

export class DirectionalCostType extends DirectionalCostTypeBase { }